/**
 * Normaliza URLs de archivos devueltas por la API (públicas legacy, protocol-relative o prefirmadas).
 */
export function normalizeSecureFileUrl (url) {
  if (!url) return null

  if (typeof url === 'object') {
    if (url.url) url = url.url
    else return null
  }

  let normalized = String(url)

  if (normalized.includes('/system')) {
    const parts = normalized.split('/')
    parts.splice(parts.indexOf('system'), 1)
    normalized = parts.join('/')
  }

  if (normalized.startsWith('//')) {
    return `https:${normalized}`
  }

  return normalized
}

export function isPresignedOrExternalFileUrl (url) {
  const normalized = normalizeSecureFileUrl(url)
  if (!normalized) return false
  if (normalized.includes('missing.png')) return false
  return normalized.startsWith('http')
}

/** Informe automático DataCrédito en gw-reports (no es adjunto Paperclip). */
export function isDatacreditoReportUrl (url) {
  const normalized = normalizeSecureFileUrl(url)
  if (!normalized) return false
  return /\/datacredit\/\d+/i.test(normalized)
}

export function isPolygraphFileUrl (polygraphAttachment) {
  return isPresignedOrExternalFileUrl(polygraphAttachment)
}
